import { useToasts } from '../store/toast';
export function Toasts() { const items = useToasts((s) => s.items); return <div className="toasts" role="status" aria-live="polite">{items.map((t) => <div key={t.id} className={`toast ${t.kind}`}>{t.text}</div>)}</div>; }
